import React from 'react';
import { Maximize2, Minimize2, LayoutGrid, List, Grid3x3, Activity } from 'lucide-react';
export type ViewDensity = 'compact' | 'comfortable' | 'spacious';
export type ViewMode = 'lanes' | 'heatmap';
interface ViewControlsProps {
  density: ViewDensity;
  onDensityChange: (density: ViewDensity) => void;
  allExpanded: boolean;
  onToggleAll: () => void;
  viewMode?: ViewMode;
  onViewModeChange?: (mode: ViewMode) => void;
}
export function ViewControls({
  density,
  onDensityChange,
  allExpanded,
  onToggleAll,
  viewMode = 'lanes',
  onViewModeChange
}: ViewControlsProps) {
  return <div className="flex items-center space-x-2" data-id="element-376">
      {/* View Mode Toggle */}
      {onViewModeChange && <div className="flex items-center space-x-1 bg-white border border-slate-200 rounded-lg p-1 shadow-sm" data-id="element-377">
          <button onClick={() => onViewModeChange('lanes')} className={`p-2 rounded-md transition-all ${viewMode === 'lanes' ? 'bg-blue-100 text-blue-700 shadow-sm' : 'text-slate-500 hover:bg-slate-100'}`} title="Swim lanes view" data-id="element-378">
            <List className="w-4 h-4" data-id="element-379" />
          </button>
          <button onClick={() => onViewModeChange('heatmap')} className={`p-2 rounded-md transition-all ${viewMode === 'heatmap' ? 'bg-blue-100 text-blue-700 shadow-sm' : 'text-slate-500 hover:bg-slate-100'}`} title="Heat map view" data-id="element-380">
            <Activity className="w-4 h-4" data-id="element-381" />
          </button>
        </div>}

      {/* Density and Expand/Collapse (only for lanes view) */}
      {viewMode === 'lanes' && <div className="flex items-center space-x-2 bg-white border border-slate-200 rounded-lg p-1 shadow-sm" data-id="element-382">
          {/* Density Toggle */}
          <div className="flex items-center space-x-1 border-r border-slate-200 pr-2" data-id="element-383">
            <button onClick={() => onDensityChange('compact')} className={`p-2 rounded-md transition-all ${density === 'compact' ? 'bg-blue-100 text-blue-700 shadow-sm' : 'text-slate-500 hover:bg-slate-100'}`} title="Compact view" data-id="element-384">
              <Grid3x3 className="w-4 h-4" data-id="element-385" />
            </button>
            <button onClick={() => onDensityChange('comfortable')} className={`p-2 rounded-md transition-all ${density === 'comfortable' ? 'bg-blue-100 text-blue-700 shadow-sm' : 'text-slate-500 hover:bg-slate-100'}`} title="Comfortable view" data-id="element-386">
              <LayoutGrid className="w-4 h-4" data-id="element-387" />
            </button>
            <button onClick={() => onDensityChange('spacious')} className={`p-2 rounded-md transition-all ${density === 'spacious' ? 'bg-blue-100 text-blue-700 shadow-sm' : 'text-slate-500 hover:bg-slate-100'}`} title="Spacious view" data-id="element-388">
              <List className="w-4 h-4" data-id="element-389" />
            </button>
          </div>

          {/* Expand/Collapse All */}
          <button onClick={onToggleAll} className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 rounded-md transition-colors" data-id="element-390">
            {allExpanded ? <>
                <Minimize2 className="w-4 h-4" data-id="element-391" />
                <span data-id="element-392">Collapse All</span>
              </> : <>
                <Maximize2 className="w-4 h-4" data-id="element-393" />
                <span data-id="element-394">Expand All</span>
              </>}
          </button>
        </div>}
    </div>;
}